import { FC } from "react";
import FilterBudgetIcon from "@/assets/icons/budgets/FilterBudgetIcon.svg";
import ReportBudgetIcon from "@/assets/icons/budgets/ReportBudgetIcon.svg";

interface BudgetIconProps {
  base: "billingExplorerReport" | "filters";
}

export const BudgetIcon: FC<BudgetIconProps> = ({ base }) => {
  const iconSrc = base === "filters" ? FilterBudgetIcon : ReportBudgetIcon;

  return <img src={iconSrc} alt="budgetIcon" />;
};
